import styled from 'styled-components';
import {transparentize} from 'polished';

export const LabelWrapper = styled.div`
  margin-bottom: 10px;
  transition: .08s ease;
  align-items: center;
  grid-template-columns: 1fr max-content 1fr;
  grid-auto-flow: column;
  display: grid;

  &:before,
  &:after {
    content: "";

    width: 100%;
    height: 1px;
    display: grid;
    border-bottom: 1px solid ${({theme}) => `
      ${theme.variables.borderColor};
    `};
  }
`;

export const LabelContent = styled.span`
  box-sizing: border-box;
  padding: 0 24px;

  text-align: center;
  line-height: 18px;
  font-size: 12px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
`;
